import { getI18nFromGeneral } from '@/src/tools/tools';
import { get } from 'lodash';
import React, { memo } from 'react';
import { useHistory } from 'react-router';
import { useSalesChannel } from 'src/constrains/SalesChannelHOC/useSalesChannel';
import { useI18n } from 'src/hooks/useRouterChange';
import _TopLeft from 'src/layout/EditorPageLayout/GoBackAndBreadCrumb/GoBackAndBreadCrumb';
import { i18nGet } from 'src/tools/tools';
const TopLeft = memo(() => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const s = useSalesChannel();
  const uuid = get(s, 'uuid');
  const name = get(s, 'name');
  const h = useHistory();
  const goBack = () => {
    h.push(`/salesChannel/settings/${uuid}`);
  };
  const breadcrumbData = [
    {
      url: '/',
      name: getI18nFromGeneral('general.sider.home'),
    },
    {
      url: '/salesChannels',
      name: getI18nFromGeneral('general.sider.salesChannel'),
    },
    {
      url: `/salesChannel/content/${uuid}`,
      name: name || getI18nFromGeneral('general.sider.salesChannel'),
    },
    {
      url: `/salesChannel/settings/${uuid}`,
      name: getI18nFromGeneral('general.sider.settings'),
    },
    {
      url: ``,
      name: getI18n('salesChannelCheckout.index.checkout'),
    },
  ];
  return <_TopLeft goBack={goBack} breadcrumbData={breadcrumbData} />;
});
export default TopLeft;
